import { render, staticRenderFns } from "./ContractorFaults.vue?vue&type=template&id=95877400&"
import script from "./ContractorFaults.vue?vue&type=script&lang=js&"
export * from "./ContractorFaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports